import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';
import { HomeComponent } from './components/public/home/home.component';
import { LoginComponent } from './components/public/login/login.component';
import { AuthCallbackComponent } from './components/public/auth-callback/auth-callback.component';
import { RegistrationLayoutComponent } from './layouts/registration-layout/registration-layout.component';
import { RegisterComponent } from './components/public/register/register.component';
import { VerifyEmailComponent } from './components/public/verify-email/verify-email.component';
import { VerificationCompleteComponent } from './components/public/verification-complete/verification-complete.component';
import { ReviewSetupComponent } from './components/public/review-setup/review-setup.component';
import { RoleGuard } from './guards/role.guard';
import { LoginRedirectGuard } from './guards/login-redirect.guard';
import { PlanSelectedGuard } from './guards/plan-selected.guard';

const routes: Routes = [
  // Eager public routes — home page, login, auth callback
  {
    path: '',
    component: PublicLayoutComponent,
    data: { title: 'Home' },
    children: [
      { path: '', component: HomeComponent, data: { title: 'Home' } },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [LoginRedirectGuard],
        data: { title: 'Login' },
      },
      {
        path: 'auth/callback',
        component: AuthCallbackComponent,
        data: { title: 'Authorizing' },
      },
    ],
  },
  // Eager registration routes — linked directly from home CTA
  {
    path: '',
    component: RegistrationLayoutComponent,
    data: { title: 'Registration' },
    children: [
      { path: 'register', component: RegisterComponent, canActivate: [PlanSelectedGuard], data: { title: 'Registration' } },
      { path: 'review-setup', component: ReviewSetupComponent, data: { title: 'Review Setup' } },
      { path: 'verify', component: VerifyEmailComponent, data: { title: 'Email Verification' } },
      {
        path: 'verification-complete',
        component: VerificationCompleteComponent,
        data: { title: 'Verification Complete' },
      },
    ],
  },
  // Lazy-loaded authenticated routes — not needed until after login
  {
    path: 'user',
    canActivate: [RoleGuard],
    data: { title: 'User', roles: ['user'] },
    loadChildren: () => import('./modules/user.module').then(m => m.UserModule),
  },
  {
    path: 'admin',
    canActivate: [RoleGuard],
    data: { title: 'Admin', roles: ['admin'] },
    loadChildren: () => import('./modules/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'partner',
    canActivate: [RoleGuard],
    data: { title: 'Partner', roles: ['reseller'] },
    loadChildren: () => import('./modules/reseller.module').then(m => m.ResellerModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      paramsInheritanceStrategy: 'always',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
